// extracted by mini-css-extract-plugin
module.exports = {"tabItem":"tab-menu-item_tabItem__JKxYG","tabItem--active":"tab-menu-item_tabItem--active__oaJyK","counter":"tab-menu-item_counter__a4t5Z"};